"use client";

import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/digitalmarketingsam4u/",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://www.linkedin.com/company/sambrandmarketing",
    label: "LinkedIn"
  }];
  return <footer ref={ref} className={`relative bg-muted-light-background py-16 transition-opacity duration-[var(--duration-slow)] ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
    backgroundImage: `
          repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            hsl(0, 0%, 92%) 10px,
            hsl(0, 0%, 92%) 20px
          )
        `
  }}>
      <div className="container mx-auto px-4 flex flex-col items-center gap-12">
        {}
        <div className="flex justify-center">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/sam_branding_marketing_footer_logo.png" alt="Sam Branding & Marketing" className="h-7" />
        </div>

        {}
        <div className="flex items-center gap-4">
          {socialLinks.map((social, i) => {
          const Icon = social.icon;
          return <Link key={social.label} to={social.href} aria-label={social.label} newTab data-index={i} className="flex items-center justify-center w-12 h-12 rounded-full bg-background shadow-[var(--shadow-card)] hover:shadow-[0_8px_32px_rgba(0,0,0,0.16),0_0_24px_rgba(255,215,0,0.3)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:bg-primary hover:text-foreground-primary hover:-translate-y-0.5 hover:border hover:border-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40">
                <Icon className="w-6 h-6" />
              </Link>;
        })}
        </div>

        {}
        <p className="text-sm text-foreground-muted-light text-center">
          © {new Date().getFullYear()} Sam Branding & Marketing. All rights
          reserved.
        </p>
      </div>
    </footer>;
}